import { Redirect } from "expo-router"
import { useAuth } from "../hooks/use-auth"

export default function Index() {
  const auth = useAuth()
  if (auth.isLoading) return null
  return <Redirect href={auth.data?.id ? "/dashboard" : "/login"} />
}
